/**
 * a Singleton implementation of the Engagement Simulator
 * This simulator has one main purpose which is to simulate an addition of an engagement to the system.
 * It does it by adding to the model (given upon initialization) the right data structures that simulate the data of the visit, engagement and the participant simulated.
 */

define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var lpUtils = require('utils/lpUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var ViewController = require('web-agent-framework/ViewController');

    /////////////////////////////////// PRIVATE VARIABLES - START //////////////////////////
    var singletonInstance;
    var dataModel;
    /////////////////////////////////// PRIVATE VARIABLES - END ////////////////////////////

    /**
     * Constructor method
     * @param model
     * @constructor
     */
    function EngagementSimulator(model) {
        dataModel = model;
        // Notifying the LE FW that the widgets area is visible
        var webAgentChannel = agentLEManager.channelLE();
        var webAgentMediaCodes = agentLEManager.getLEMediaCodesWebAgent();
        webAgentChannel.comply(webAgentMediaCodes.commands.showSimulatedEngagement, addSimulatedEngagement.bind(this));
        webAgentChannel.comply(webAgentMediaCodes.commands.hideSimulatedEngagement, removeSimulatedEngagement.bind(this));
    }

    /////////////////////////////////// PUBLIC METHODS - START ///////////////////////////////////
    EngagementSimulator.prototype.SIMULATED_PARTICIPANT_ID = "simulatedParticipant";

    EngagementSimulator.prototype.isSimulatedEngagementVisible = function () {
        return singletonInstance.simulatedEngagementVisible;
    };

    /////////////////////////////////// PRIVATE METHODS - START //////////////////////////////////

    /**
     * This method will add a simulated engagement to the model
     */
    function addSimulatedEngagement() {
        var participantData = lpUtils.cloneObject(require('web-agent-utils/Config/simulatedParticipantData.json'));
        participantData.participantInfo.lang = agentLEManager.getDefaultLanguage();
        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.SIMULATED_PARTICIPANT_ID);
        dataModel.modify(participantPath, participantData);
        var visitData = lpUtils.cloneObject(require('web-agent-utils/Config/simulatedVisitData.json'));
        dataModel.modify("participants.info." + this.SIMULATED_PARTICIPANT_ID, visitData);
        var engagementData = lpUtils.cloneObject(require('web-agent-utils/Config/simulatedEngagementData.json'));
        dataModel.modify("chats." + this.SIMULATED_PARTICIPANT_ID, engagementData);
        singletonInstance.simulatedEngagementVisible = true;
        if (dataModel.get('agent.acd.autoAnswering') == 'true') {
            ViewController.viewEventsHandler.fireEvent({appName: this.SIMULATED_PARTICIPANT_ID, UIEvent: ViewController.viewEventsHandler.eventType.VISITOR_FOCUSED});
        }
    }

    /**
     * This method will remove the simulated engagement from the model
     */
    function removeSimulatedEngagement() {
        lpTag.WebAgent.logicController.disposeParticipant(this.SIMULATED_PARTICIPANT_ID);
        ViewController.viewEventsHandler.fireEvent({
            appName: this.SIMULATED_PARTICIPANT_ID,
            UIEvent: ViewController.viewEventsHandler.eventType.VISITOR_DISPOSED,
            eventData: {
                visitorId: this.SIMULATED_PARTICIPANT_ID
            },
            deleteOnFire: true
        });
        singletonInstance.simulatedEngagementVisible = false;
    }

    /////////////////////////////////// PRIVATE METHODS - END ///////////////////////////////////

    return {
        getInstance: function (model) {
            if (!singletonInstance) {
                singletonInstance = new EngagementSimulator(model);
            }
            return singletonInstance;
        }
    };

});
